<template>
  <div class="list-view outside-view">
    <!-- <div class="filter-warp" >
      <div class="cur-router-msg">
        <div class="router-msg">
          <breadcrumb></breadcrumb>
        </div>
      </div>
    </div> -->
    <div class="wrapper">
      <iframe class="iframe" id="ifrmname" scrolling="auto" seamless :src="src" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'OutsideView',
  // components: { Breadcrumb },
  data () {
    return {
      src: ''
    }
  },
  computed: mapState(['token', 'rootMenu', 'leafMenu']),
  watch: {
    $route () {
      this.showFrameFlag = false
      this.setSrc()
    }
  },
  methods: {
    setSrc () {
      let leafMenu = this.rootMenu.children.map(sub => sub.children).reduce((prev, cur) => prev.concat(cur)).find(menu => menu.path === this.leafMenu.path)
      this.src = `${leafMenu.outModuleUrl}?seen=false&systemCode=OVERALL_SERVICE&token=${this.token}`
      setTimeout(() => {
        window.frames[0].location.reload()
      }, 500)
    }
  },
  created () {
    this.setSrc()
  }
}
</script>

<style lang="less" scoped>
.outside-view {
  .wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 0 0 0;
    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>